import { render, staticRenderFns } from "./companyIntegral.vue?vue&type=template&id=6218430c&"
import script from "./companyIntegral.vue?vue&type=script&lang=js&"
export * from "./companyIntegral.vue?vue&type=script&lang=js&"
import style0 from "./companyIntegral.vue?vue&type=style&index=0&id=6218430c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports